import { Modal, DotLoading, Grid,Toast } from "antd-mobile";
import styled from "styled-components";
import { useState, useEffect } from "react";
import { getCardEarnings } from "../../../../api";
import Image from "../../../../components/Image";
import { displayNum } from "../../../../utils/utils";
import { useIntl } from "react-intl";
// 属性卡详情
export default function useQuilityModal() {
  const intl = useIntl();
  const unmount_text = intl.formatMessage({
    id: "components.card_modal.unmount",
    defaultMessage: "卸下",
  });
  const transfer_text = intl.formatMessage({
    id: "components.card_modal.tranfer",
    defaultMessage: "轉讓",
  });
  const cancel_text = intl.formatMessage({
    id: "common.cancel",
    defaultMessage: "取消",
  });

  const show = ({ onConfrim = () => {}, quility = {}, mountedEquip }) => {
    return Modal.show({
      title: "",
      bodyClassName: "runbit_modal",
      showCloseButton: true,
      actions: [
        {
          key: mountedEquip ? "1" : "3",
          className: "border_btn",
          text: mountedEquip ? unmount_text : cancel_text,
        },
        {
          key: "2",
          className: "primary_btn",
          text: transfer_text,
          primary: true,
        },
      ],
      onAction: (action, index) => {
        if(action.key === '2') {
          if(quility && quility.count) {
            Toast.show({
              content: intl.formatMessage({
                id:'common.used_card_tip'
              })
            })
            return 
          }
        }
        onConfrim(action);
      },
      closeOnAction: false,
      content: (
        <QuilityModal
          quility={quility}
          mountedEquip={mountedEquip}
          intl={intl}
        />
      ),
    });
  };
  return {
    show,
  };
}

function QuilityModal({ quility, mountedEquip, intl }) {
  const [loading, setLoading] = useState(false);
  const [reward, setReward] = useState(false);
  const consume_text = intl.formatMessage({
    id: "components.card_modal.consume",
    defaultMessage: "耐久",
  });

  const synced_today_text = intl.formatMessage({
    id:'common.synced_today',
    defaultMessage:'今日已同步'
  })
  const accumulated_profit_text = intl.formatMessage({
    id: "components.card_modal.accumulated_profit",
    defaultMessage: "累計收益",
  });
  const be_mounted_text = intl.formatMessage({
    id: "components.card_modal.be_mounted",
    defaultMessage: "已安装于装备",
  });
  useEffect(() => {
    if (quility) {
      console.log('quility',quility)
      getReward();
    }
  }, [quility]);
  const getReward = async () => {
    setLoading(true);
    const res = await getCardEarnings(quility.id);
    setReward(res.data);
    setLoading(false);
  };
  return (
    <div className="text-center">
      <ImageWrapper>
        <Image
          width={"16.8rem"}
          height={"25.2rem"}
          src={quility.img}
          alt={quility.id}
        />
      </ImageWrapper>
      <Detail>
        <Grid columns={(quility && quility.count) ? 3 : 2} gap={8}>
          <Grid.Item>
            <div>{consume_text}</div>
            <div style={{ marginTop: ".8rem" }}>
              <strong>
                {quility.consume}/
                {quility && quility.card && quility.card.durability}
              </strong>
            </div>
          </Grid.Item>
          <Grid.Item>
            <div>{accumulated_profit_text}</div>
            <div style={{ marginTop: ".8rem" }}>
              <strong>{loading ? <DotLoading /> : displayNum(reward)}</strong>
            </div>
          </Grid.Item>
          {(quility && quility.count) ? <Grid.Item >
            <div>{synced_today_text}</div>
            <div style={{ marginTop: ".8rem" }}>
              <strong>{ intl.formatMessage({
                id: 'pages.home.step'
              },{
                  step:quility && quility.count
              })}</strong>
            </div>
          </Grid.Item> : null}
        </Grid>
      </Detail>
      {mountedEquip ? (
        <Tip>
          {be_mounted_text}# {mountedEquip.id}
        </Tip>
      ) : null}
    </div>
  );
}
const ImageWrapper = styled.div`
  min-height: 8.0rem;

  display: inline-block;
`;

const Detail = styled.div`
  background: #f4f5f6;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 1.6rem;
  padding: 1.6rem 1.0rem 1.6rem 2.0rem;
  margin-top: 2.0rem;
  text-align: left;
  font-style: normal;
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1.3rem;

  color: #969696;
  strong {
    font-size: 1.4rem;
    line-height: 1.4rem;

    color: #000000;
  }
`;

const Tip = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;

  color: #969696;
  margin-top: 2.0rem;
  strong {
    color: #000;
  }
`;
